
import React from 'react';
import { useMobileNavigation } from './useMobileNavigation';
import { MobileMenuHeader } from './MobileMenuHeader';
import { MobileNavigationItem } from './MobileNavigationItem';
import { NavItem } from './types';
import { useAuth } from '@/hooks/useAuth';

interface MobileNavigationProps {
  isOpen: boolean;
  navItems: NavItem[];
  isActive: (href: string) => boolean;
  onClose: () => void;
  onNavigationClick?: (href: string) => void;
}

export const MobileNavigation: React.FC<MobileNavigationProps> = ({
  isOpen,
  navItems,
  isActive,
  onClose,
  onNavigationClick
}) => {
  const { hasAdminAccess } = useAuth();
  const {
    menuRef,
    panelWidth,
    expanded,
    handleOverlayClick,
    toggleExpand,
  } = useMobileNavigation({ isOpen, onClose });

  if (!isOpen) {
    return null;
  }

  return (
    <div 
      className="fixed inset-0 z-[999999] bg-transparent lg:hidden"
      onClick={handleOverlayClick} 
      role="dialog" 
      aria-label="Mobile menu" 
      aria-modal="true"
      style={{ 
        touchAction: 'none'
      }}
    >
      <div
        className="bg-white h-full w-full overflow-hidden"
        onClick={e => e.stopPropagation()}
        role="menu"
        tabIndex={-1}
        id="mobile-navigation"
        ref={menuRef}
      >
        <MobileMenuHeader onClose={onClose} />
        
        {/* Scrollable content area */}
        <div 
          className="overflow-y-auto overscroll-contain h-[calc(100vh-80px)]" 
          style={{ 
            WebkitOverflowScrolling: 'touch',
            paddingBottom: 'env(safe-area-inset-bottom)'
          }}
        >
          <nav className="px-4 pt-4 pb-8 space-y-3" aria-labelledby="menu-title">
            {navItems?.length ? (
              navItems
                .filter(item => !item.adminOnly || hasAdminAccess())
                .map((item) => (
                <MobileNavigationItem
                  key={item.label}
                  item={item}
                  isActive={isActive}
                  expanded={expanded}
                  onToggleExpand={toggleExpand}
                  onClose={onClose}
                  onNavigationClick={onNavigationClick}
                />
              ))
            ) : (
              <div className="text-center py-8 text-muted-foreground">
                No navigation items available
              </div>
            )}
          </nav>
        </div>
      </div>
    </div>
  );
};
